module.exports = __webpack_public_path__ + "img/hezuoqijian.db8b5edb.png";